var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company"},[_c('MobileSidebarWrapper',{attrs:{"param":"subId"}},[_c('template',{slot:"sidebar"},[_c('Sidebar')],1),_c('template',{slot:"content"},[_c('router-view')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }